/**
 * GST column label for detected / manual line item tables when company GST is enabled.
 * Aligns with EditLineItem* "NO TAX": tax_id NO_TAX or unset with 0% rate.
 */
export function formatDetectedLineItemGstDisplay(item: {
  tax_id?: string | null;
  tax_percentage?: number | null;
}): string {
  const tid = (item.tax_id ?? "").trim();
  if (tid === "NO_TAX" || tid === "") return "No Tax";
  const pct = Number(item.tax_percentage ?? 0);
  return `${pct}%`;
}
